import { h } from "@stencil/core";
/**
 * A container for `es-aciton-*` elements, to be used in tables or panel headers.
 */
export class ESActions {
    render() {
        return h("slot", { key: 'd55eb74ddaa3cca5c3c211229d2fa914d5dbac00' });
    }
    static get is() { return "es-actions"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-actions.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-actions.css"]
        };
    }
}
//# sourceMappingURL=es-actions.js.map
